import { render, staticRenderFns } from "./ConfirmAccount.vue?vue&type=template&id=ffbd4230&scoped=true"
import script from "./ConfirmAccount.vue?vue&type=script&lang=js"
export * from "./ConfirmAccount.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAccount.vue?vue&type=style&index=0&id=ffbd4230&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbd4230",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffbd4230')) {
      api.createRecord('ffbd4230', component.options)
    } else {
      api.reload('ffbd4230', component.options)
    }
    module.hot.accept("./ConfirmAccount.vue?vue&type=template&id=ffbd4230&scoped=true", function () {
      api.rerender('ffbd4230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/ConfirmAccount.vue"
export default component.exports